import styled from "styled-components";
import { BlockStyled } from "../../../styles/shared-styles";

export const LoginPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs}%;
`;

export const BlockLoginStyled = styled(BlockStyled)`
  width: 34vw;
`;
